import React, { useEffect, useState } from "react";
import AdminLTE, {
  Sidebar,
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
  Label,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";

import "react-phone-input-2/lib/style.css";


const { Select2, Date, DateTime, Text } = Inputs;

function ChangePassByToken({ history, match }) {
  const dispatch = useDispatch();
  const modelChangePass = useSelector((state) => state.changePassByToken);
  const modelCheckToken = useSelector((state) => state.checkResetToken);
  const [password, setPassword] = useState(null);
  const [password2, setPassword2] = useState(null);

  useEffect(() => {
    const data = modelChangePass?.data?.data;
    const error = modelChangePass?.error;
    const errorMessage = modelChangePass?.error?.response?.data?.mensaje;

    if (error) {
      alert(errorMessage || 'Ocurrió un error al realizar la operación');
      dispatch(controller.duckChangePassByToken.actions.clear());
    }
    if (data) {
      alert("Contraseña actualizada");
      history.push("/login");
      dispatch(controller.duckChangePassByToken.actions.clear());
    }
  }, [modelChangePass]);

  useEffect(() => {
    const data = modelCheckToken?.data?.data;
    const errorMessage = modelCheckToken?.error?.response?.data?.mensaje;
    const error = modelCheckToken?.error;

    if (error) {
      alert(errorMessage || 'Ocurrió un error al realizar la operación');
      dispatch(controller.duckCheckResetToken.actions.clear());
      history.push("/login");
    }
    if (data) {
      dispatch(controller.duckCheckResetToken.actions.clear());
    }
  }, [modelCheckToken]);

  useEffect(() => {
    const resetToken = match.params.resetToken;
    dispatch(controller.checkResetTokenThunk(resetToken));
  }, []);

  function submit() {
    if (!password || !password2) {
      return alert("Por favor complete todos los campos");
    }
    if (password !== password2) {
      return alert("Las contraseñas no coinciden");
    }
    let data = {
      password,
      resetToken: match.params.resetToken,
    };
    dispatch(controller.changePassByTokenThunk(data));
  }
  return (
    <Content
      title="Olvide mi contraseña"
      browserTitle="Olvide mi contraseña"
      show={false}
    >
      <Row>
        <Col md="4" mdOffset="4">
          <Box title="Generar nueva contraseña">
            <Text
              inputType="password"
              labelPosition="above"
              size="sm"
              label="Password"
              onChange={(evt) => setPassword(evt.target.value)}
            />
            <Text
              inputType="password"
              labelPosition="above"
              size="sm"
              label="Password"
              onChange={(evt) => setPassword2(evt.target.value)}
            />
            <Button
              type="primary"
              text="Guardar"
              pullRight={true}
              onClick={() => submit()}
            />
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default ChangePassByToken;
